import { render } from "./DemoProduct.vue?vue&type=template&id=c13fc92a"
import script from "./DemoProduct.vue?vue&type=script&lang=js"
export * from "./DemoProduct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__